module.exports = __webpack_public_path__ + "static/media/fit_personal_advising.33833236.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fit_personal_advising.png
// module id = 475
// module chunks = 21